import { render, staticRenderFns } from "./ContractsDocument.vue?vue&type=template&id=04ca6cc0&scoped=true"
import script from "./ContractsDocument.vue?vue&type=script&lang=js"
export * from "./ContractsDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ca6cc0",
  null
  
)

export default component.exports